/**
 * Where in a chapter each reading-progress event fires, as a fraction of the
 * chapter's rendered height. The reader treats a mark as reached when that pixel
 * offset enters the viewport.
 *
 * COMPLETED_CHAPTER used to sit at 1.0 — the chapter's very last pixel. Measuring
 * real progress data showed that offset is frequently never reached: a reader who
 * moves on while the closing lines are still below the fold never registers as
 * having finished the chapter, so `PartReaderProgress.completedAt` came out far
 * sparser than actual reading (see
 * docs/features/reader-completion/README.md §4b).
 *
 * 0.9 keeps the event meaning "read essentially all of it" while making it
 * reachable in normal reading. This only affects data collected from here on;
 * it does not reinterpret anything already stored.
 */
export const CHAPTER_START_FRACTION = 0;
export const CHAPTER_FIRST_QUARTILE_FRACTION = 0.25;
export const CHAPTER_MID_FRACTION = 0.5;
export const CHAPTER_THIRD_QUARTILE_FRACTION = 0.75;
export const CHAPTER_COMPLETE_FRACTION = 0.9;

/**
 * Pixel offsets of each mark for a chapter of `height` pixels.
 */
export const getTrackingOffsets = height => {
  const h = Number(height) || 0;
  return {
    start: h * CHAPTER_START_FRACTION,
    firstQ: h * CHAPTER_FIRST_QUARTILE_FRACTION,
    mid: h * CHAPTER_MID_FRACTION,
    thirdQ: h * CHAPTER_THIRD_QUARTILE_FRACTION,
    complete: h * CHAPTER_COMPLETE_FRACTION
  };
};
